import * as R from 'remeda';
import type { ActivityRow } from '../model';

const countRowValueChanges = (row: ActivityRow): number =>
  row.kind === 'table'
    ? R.sumBy(row.rows, tableRow => tableRow.cells.length)
    : 1;

export const countValueChanges = (rows: ActivityRow[]): number =>
  R.sumBy(rows, countRowValueChanges);

const sliceRow = (row: ActivityRow, maxChanges: number): ActivityRow | null => {
  if (maxChanges <= 0) return null;
  if (row.kind !== 'table') return row;

  let remaining = maxChanges;
  const tableRows = row.rows.flatMap(tableRow => {
    const cells = tableRow.cells.slice(0, remaining);
    remaining -= cells.length;
    return cells.length > 0 ? [{ ...tableRow, cells }] : [];
  });
  return { ...row, rows: tableRows };
};

export const sliceValueChanges = (
  rows: ActivityRow[],
  maxChanges: number
): ActivityRow[] => {
  let remaining = maxChanges;
  return rows.flatMap(row => {
    const taken = sliceRow(row, remaining);
    if (!taken) return [];
    remaining -= countRowValueChanges(taken);
    return [taken];
  });
};
